import { useState } from 'react';
import { ImageStorageService } from '../services/storage/imageStorageService';
import { useToast } from './useToast';
import { ImageProcessingError, getImageErrorMessage } from '../utils/errors';

export const useImageUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const { showToast } = useToast();
  const storageService = new ImageStorageService();

  const uploadImage = async (file: File): Promise<string | null> => {
    setIsUploading(true);

    try {
      // Vérifier si on est dans un navigateur
      if (typeof window === 'undefined') {
        // Côté serveur, utiliser le buffer
        const buffer = await file.arrayBuffer();
        const imageUrl = await storageService.uploadContestantImage(
          Buffer.from(buffer),
          file.type
        );
        showToast('Image téléchargée avec succès', 'success');
        return imageUrl;
      } else {
        // Côté navigateur, envoyer directement le fichier
        const imageUrl = await storageService.uploadContestantImage(file, file.type);
        showToast('Image téléchargée avec succès', 'success');
        return imageUrl;
      }
    } catch (error) {
      console.error('Erreur lors du téléchargement de l\'image:', error);
      const errorMessage = error instanceof Error ? error.message : 'Erreur inconnue';
      showToast(`Erreur lors du téléchargement: ${errorMessage}`, 'error');
      return null;
    } finally {
      setIsUploading(false);
    }
  };

  const deleteImage = async (imageUrl: string): Promise<boolean> => {
    try {
      await storageService.deleteContestantImage(imageUrl);
      return true;
    } catch (error) {
      const imageError = error instanceof ImageProcessingError
        ? error
        : new ImageProcessingError('UNKNOWN_ERROR', 'Erreur lors de la suppression');
      
      showToast(getImageErrorMessage(imageError), 'error');
      return false;
    }
  };

  return {
    uploadImage,
    deleteImage,
    isUploading
  };
};